// extracted by mini-css-extract-plugin
module.exports = {"loader":"loading_loader__B5bAJ","spin":"loading_spin__PDq4L"};